import { render, staticRenderFns } from "./DrawingRequestsTab.vue?vue&type=template&id=292b64d4&"
import script from "./DrawingRequestsTab.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports